export const contact = {
	clubName: 'Karate klub Bregana',
	address: {
		street: 'Ul. Miroslava Krleže 19',
		postalCode: '10432',
		city: 'Bregana',
	},
	phones: [
		{ label: 'Tel.', value: '+385 (0)1 3375 547' },
		{ label: 'Mob.', value: '+385 (0)91 502 3422' },
	],
	email: 'gromic987@gmail.com',
}

export const socials = [
	{ label: 'Instagram', url: 'https://www.instagram.com/karate.klub.bregana/' },
	{ label: 'Facebook', url: 'https://www.facebook.com/people/Karate-klub-Bregana/100048999382551/' },
]
